import { io } from 'socket.io-client';

// Use local Socket.IO server when running on localhost, Railway otherwise.
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');

const SOCKET_URL = isLocalhost
  ? 'http://localhost:3001'
  : 'https://betmimic-production.up.railway.app';

class SocketManager {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect() {
    if (this.socket?.connected) return;

    this.socket = io(SOCKET_URL, {
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000
    });

    this.socket.on('connect', () => {
      console.log('Socket connected');
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    this.socket.on('error', (error) => {
      console.error('Socket error:', error);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  subscribeToTrader(traderAddress) {
    if (!this.socket) this.connect();
    this.socket.emit('subscribe:trader', traderAddress);
  }

  unsubscribeFromTrader(traderAddress) {
    if (this.socket) {
      this.socket.emit('unsubscribe:trader', traderAddress);
    }
  }

  subscribeToPositions(userId) {
    if (!this.socket) this.connect();
    this.socket.emit('subscribe:positions', userId);
  }

  // Subscribe to whale/sentinel activity for a user
  subscribeToWhale(userId) {
    if (!this.socket) this.connect();
    this.socket.emit('subscribe:whale', userId);
  }

  unsubscribeFromWhale(userId) {
    if (this.socket) {
      this.socket.emit('unsubscribe:whale', userId);
    }
  }

  refreshPaperPositions(userId) {
    if (!this.socket) this.connect();
    this.socket.emit('refreshPaperPositions', userId);
  }

  // Subscribe to real-time market price updates
  subscribeToMarket(tokenId) {
    if (!this.socket) this.connect();
    this.socket.emit('subscribe:market', tokenId);
  }

  unsubscribeFromMarket(tokenId) {
    if (this.socket) {
      this.socket.emit('unsubscribe:market', tokenId);
    }
  }

  // Subscribe to multiple markets at once
  subscribeToMarkets(tokenIds) {
    if (!this.socket) this.connect();
    this.socket.emit('subscribe:markets', tokenIds);
  }

  unsubscribeFromMarkets(tokenIds) {
    if (this.socket) {
      this.socket.emit('unsubscribe:markets', tokenIds);
    }
  }

  on(event, callback) {
    if (!this.socket) this.connect();
    this.socket.on(event, callback);
    
    // Store listener for cleanup
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
    
    // Remove from stored listeners
    if (this.listeners.has(event)) {
      const callbacks = this.listeners.get(event);
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  removeAllListeners(event) {
    if (this.socket) {
      this.socket.removeAllListeners(event);
    }
    this.listeners.delete(event);
  }
}

export const socketManager = new SocketManager();
export default socketManager;
